import React from "react";
import { Link } from "react-router-dom";

const BorderLessButton = (props) => {
  const { text, to, email, onclick, disabled } = props;
  return (
    <Link to={to} state={{ email: email ? email : "" }}>
      <button
        style={props.style}
        onClick={onclick}
        disabled={disabled}
        className="bfont-thicboi text-base font-semibold text-white hover:text-amber-200 cursor-pointer py-1 px-3 md:py-3 md:px-6"
      >
        <p>{text}</p>
      </button>
    </Link>
  );
};

export default BorderLessButton;
